// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__OwY-N","left":"Virtual_left__LHXr7","wrapper":"Virtual_wrapper__+0lIG"};